import { FieldValidation } from '../FormFieldValidationContext';
import { useReducer } from 'react';
import { formFieldValidations as formFieldValidationConfigs } from '../FormValidationContext';
import { FormFields } from '../../fields/FormFields';

type FormFieldValidationsReducerAction = {
  action: 'setFocus' | 'setValidationState';
  fieldName: FormFields | string;
  value?: any;
};

export function useFormFieldValidationContextConfigurer() {
  const onBlur = (fieldName: string) => {
    formFieldValidationsChange({ action: 'setFocus', fieldName, value: false });
  };

  const onFocus = (fieldName: string) => {
    formFieldValidationsChange({ action: 'setFocus', fieldName, value: true });
  };

  const onSetValidationState = function (
    fieldName: string,
    isValid: boolean,
    hasError: boolean,
    errorTags: string[],
  ) {
    formFieldValidationsChange({
      action: 'setValidationState',
      fieldName,
      value: {
        isValid,
        hasError,
        errorTags,
      },
    });
  };

  const configureBehavior = function (
    newFieldValidation: FieldValidation,
    fieldName: string,
  ): FieldValidation {
    newFieldValidation.setBlurMethod(onBlur.bind(null, fieldName));
    newFieldValidation.setFocusMethod(onFocus.bind(null, fieldName));
    newFieldValidation.setChangeValidationStateMethod(onSetValidationState.bind(null, fieldName));
    return newFieldValidation;
  };

  const formFieldValidationsReducer = (
    state: any,
    { action, fieldName, value }: FormFieldValidationsReducerAction,
  ) => {
    let changeDataset;
    switch (action) {
      case 'setFocus':
        changeDataset = { isFocused: value };
        break;
      case 'setValidationState':
        changeDataset = value;
        break;
      default:
        throw Error(`Unknown action ${action}`);
    }

    let newFieldValidation = (state[fieldName] as FieldValidation).createUpdated(changeDataset);
    newFieldValidation = configureBehavior(newFieldValidation, fieldName);
    return {
      ...state,
      [fieldName]: newFieldValidation,
    };
  };
  const [formFieldValidations, formFieldValidationsChange] = useReducer(
    formFieldValidationsReducer,
    formFieldValidationConfigs,
    () => {
      return Object.keys(formFieldValidationConfigs).reduce(
        (result: any, fieldName: string): any => {
          const currentValue = configureBehavior(
            formFieldValidationConfigs[fieldName as FormFields],
            fieldName,
          );
          result[fieldName] = currentValue;
          return result;
        },
        {},
      );
    },
  );

  return [formFieldValidations, formFieldValidationsChange];
}
